import Title from './Title.view';

export default Title;
